<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>
    <ion-title> {{ isEnsino ? ('Aulas' | translate) : ('Encontro' | translate) }} </ion-title>

    <ion-col class="end-filter">
      <i class="fas fa-qrcode icon-qr" (click)="leitorCheckIn()" style="margin-right: 16px"
        *ngIf="isInscrito && dataValida && !hasCheckIn"></i>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido" *ngIf="loaded"></div>

  <ng-container *ngIf="loaded">
    <ion-row style="padding-left: 10px; padding-top: 10px;" *ngIf="exibirDataValidade == 0">
      <ion-col size="12" class="border-endereco">
        <ion-label *ngIf="encontro.materia">
          <h5 class="evento-title">{{encontro.materia}}</h5>
        </ion-label>

        <p>
          <i class="fal fa-clock icon"></i>
          {{encontro.dataInicio | dateFormat:'dd MMM'}}
          {{encontro.dataInicio | dateFormat:'hora'}} - {{encontro.dataFim | dateFormat:'dd MMM'}} {{encontro.dataFim |
          dateFormat:'hora'}}
        </p>
      </ion-col>
    </ion-row>

    <div [ngSwitch]="tabSelected">
      <div *ngSwitchCase="'aula'" style="padding: 0px 11px 0px 11px">
        <div>
          <ion-list class="encontro-responsavel">
            <ion-item lines="none" class="avatar-cicle">
              <ion-avatar slot="start">
                <img [src]="encontro.foto | image:' '" />
              </ion-avatar>

              <ion-label>
                <div class="responsavel">
                  <ng-container *ngIf="encontro.responsavel"> {{encontro.responsavel}} </ng-container>

                  <ng-container *ngIf="!encontro.responsavel"> {{'Nenhum Responsável' | translate}} </ng-container>
                </div>
                <span class="responsavel-nome">{{'Responsável' | translate}}</span>
              </ion-label>
            </ion-item>
          </ion-list>

          <div *ngIf="isEnsino && layoutAula?.length && (isInscrito || isAdmin)">
            <div *ngFor="let layout of layoutAula, let i = index">
              <div *ngIf="layout.tipo == '1'" style="margin: 0 9px; padding: 3px">
                <div class="conteudo-layout" [innerHTML]="layout.conteudo | safeHtml: 'html'"></div>
              </div>

              <ion-card class="card-video ion-margin-bottom" *ngIf="layout.tipo == '2'">
                <div class="iframe-container">
                  <div>
                    <video-player [id]="i+1" [video]="layout.conteudo"></video-player>
                  </div>
                </div>
              </ion-card>

              <div *ngIf="layout.tipo == '3'">
                <img class="conteudo-imagem" [src]="layout.conteudo | image:' '" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="links.length && (isInscrito || isAdmin)">
          <ion-list *ngFor="let link of links" (click)="openLink(link);" class="remove-border ion-margin-bottom">
            <ion-item class="links">
              <ion-note slot="start" class="ion-margin-start">
                <i class="fa-solid fa-link"></i>
              </ion-note>

              <ion-label>
                <h3>{{link.nome}}</h3>
              </ion-label>

              <ion-note slot="end" class="ion-margin-end">
                <i class="fa-solid fa-chevron-right"></i>
              </ion-note>
            </ion-item>
          </ion-list>
        </div>
      </div>

      <div *ngSwitchCase="'notas'">
        <ion-grid class="timeline-container">
          <ion-row *ngFor="let atividade of atividades; let i = index" class="timeline-item">
            <ion-col size="1" class="timeline-dot-col">
              <div class="dot"></div>
              <div class="line" *ngIf="i !== atividades.length - 1"></div>
            </ion-col>

            <ion-col size="10">
              <ion-card class="info-notas">
                <ion-grid>
                  <ion-row class="ion-align-items-center">
                    <ion-col size="1">
                      <i class="fas fa-book-reader"></i>
                    </ion-col>
                    <ion-col size="11" class="remove-border ion-no-padding">
                      <ion-item style="--background: #ebf0ff">
                        <ion-label style="margin-bottom: 0">
                          <h2 class="grupo">{{atividade.nome}}</h2>
                          <p>{{atividade.descricao}}</p>
                        </ion-label>
                      </ion-item>
                    </ion-col>
                  </ion-row>

                  <ion-row>
                    <ion-col class="remove-border ion-no-padding" style="--background: #ebf0ff">
                      <ion-item style="--background: #ebf0ff">
                        <ion-label style="margin: 0px 0px 6px 0px !important">
                          <ion-row class="ion-justify-content-center">
                            <ion-col size="4">
                              <ion-label class="nota-align">
                                <p>{{ 'Nota' | translate }}</p>
                                <div>
                                  <span>{{ atividade.notaAtividade }}</span>
                                </div>
                              </ion-label>
                            </ion-col>

                            <ion-col size="6">
                              <ion-label class="nota-align">
                                <p>{{ 'Sua nota' | translate }}</p>
                                <div>
                                  <span>
                                    {{ atividade.notaPessoa ? atividade.notaPessoa / 100 : ('Não avaliado' | translate)
                                    }}
                                  </span>
                                </div>
                              </ion-label>
                            </ion-col>
                          </ion-row>
                        </ion-label>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </ion-col>

            <ion-col size="1" class="d-flex" (click)="readMore(atividade.descricao)">
              <i class="fa-solid fa-chevron-right"></i>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div *ngSwitchCase="'escala'">
        <div class="prox-event ion-padding">
          <ion-card-header>
            <div class="data-evento-mes">
              <span class="mes-evento"> {{'Encarregados' | translate}} </span>

              <i *ngIf="userProvider.isAdmEscala()" (click)="openEscala()" class="fal fa-cog ion-padding-end"></i>
            </div>
          </ion-card-header>

          <ion-searchbar show-cancel-button="never" class="searchbar" (ionCancel)="onCancel()"
            placeholder="{{'Buscar Encarregado' | translate}}" [(ngModel)]="filtro.q" (ionInput)="onInput()">
          </ion-searchbar>

          <ion-list *ngFor="let encarregados of encarregadoList;" class="remove-border">
            <div class="escalas">
              <ion-item class="avatar-cicle ion-padding-bottom ion-padding-top">
                <ion-avatar slot="start">
                  <img [src]="encarregados.pessoa.foto | image:' '" />
                </ion-avatar>

                <ion-label>
                  <h3 class="item-title">
                    <ion-icon *ngIf="encarregados.presenca == '1'" class="green icon-margin" name="checkmark-circle">
                    </ion-icon>
                    <span> {{encarregados.pessoa.nome}}</span>
                  </h3>

                  <p>{{encarregados.pessoaFuncoesEspec.funcao}}</p>
                </ion-label>
              </ion-item>
            </div>
          </ion-list>

          <sem-registro *ngIf="!encarregadoList.length" [text]="'Nenhum Encarregado Localizado'"></sem-registro>
        </div>

        <ion-infinite-scroll (ionInfinite)="loadEncarregados($event)"
          *ngIf="pagination.currentPage < pagination.pageCount">
          <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>

      <div *ngSwitchCase="'gerenciar'">
        <div class="gerenciar-container">
          <ion-row style="padding: 20px;">
            <ion-col>
              <span class="box">
                <i class="fa-thin fa-user-check" style="color: var(--theme-color3) !important;font-size: medium !important;"></i>
              </span>

              <span class="date-evento"> {{ qtdCheckInRealizado }}/{{ quantidadeInscritos }} {{ textoCheckin }} </span>
            </ion-col>
          </ion-row>

          <div style="display: flex">
            <ion-searchbar class="searchbar ion-margin-start" show-cancel-button="never"
              (ionCancel)="onCancelInscritos()" placeholder="{{'Buscar Inscrito' | translate}}"
              [(ngModel)]="filtroInscritos.q" (ionInput)="onInputInscritos()">
            </ion-searchbar>

            <div class="center">
              <i (click)="leitor()" class="fas fa-qrcode icon-qr"></i>
            </div>
          </div>

          <div *ngIf="inscritosList.length" class="gerenciar">
            <ion-row *ngFor="let participante of inscritosList let i = index" class="border">
              <ion-col size="12" style="padding: 0px !important">
                <ion-list lines="full">
                  <ion-item-sliding #slidingItem>
                    <ion-item #item id="item{{i}}" (click)="openOption(slidingItem, item, participante)">
                      <ion-grid>
                        <ion-row class="ion-align-items-center">
                          <ion-col size="2">
                            <ion-avatar>
                              <img [src]="participante.foto | image:' '" />
                            </ion-avatar>
                          </ion-col>

                          <ion-col size="9">
                            <ion-label>
                              <div class="item-description">
                                <p class="description-text titulo-name">{{participante.nome}}</p>
                              </div>

                              <div class="item-description">
                                <i class="fa-solid fa-arrow-right-from-bracket icon-entrada description-icon"></i>

                                <p class="description-text data-check" *ngIf="participante.data_check_in">
                                  {{participante.data_check_in | dateFormat:'dataHora'}}
                                </p>

                                <p class="description-text data-check" *ngIf="!participante.data_check_in">
                                  {{'Não Informado' | translate}}
                                </p>
                              </div>

                              <div class="item-description">
                                <i class="fa-solid fa-left-from-bracket icon-saida-presenca"></i>

                                <p class="description-text data-check" *ngIf="participante.data_check_out">
                                  {{participante.data_check_out | dateFormat:'dataHora'}}
                                </p>

                                <p class="description-text data-check" *ngIf="!participante.data_check_out">
                                  {{'Não Informado' | translate}}
                                </p>
                              </div>

                              <div class="description-text">
                                <ion-badge *ngIf="participante.status == 0" class="failed">
                                  {{ 'Não Configurado' | translate }}
                                </ion-badge>

                                <ion-badge *ngIf="participante.status == 1 && participante.valorTotal > 0"
                                  class="success">
                                  {{ 'Quitado' | translate }}
                                </ion-badge>

                                <ion-badge
                                  *ngIf="participante.status == 1 && (!participante.valorTotal || participante.valorTotal == 0)"
                                  class="success">
                                  {{ 'Gratuito' | translate }}
                                </ion-badge>

                                <ion-badge *ngIf="participante.status == 2">
                                  {{ 'Parcelas: ' | translate }} {{ participante.parcelaAtual }}/{{
                                  participante.totalParcelas }}
                                </ion-badge>

                                <ion-badge *ngIf="participante.status == 3"> {{ 'Vencido' | translate }} </ion-badge>
                              </div>
                            </ion-label>
                          </ion-col>

                          <ion-col size="1">
                            <ion-note
                              *ngIf="(hasConfig == '1' && (participante.parcelaAtual >= 1 || participante.status == 1)) || hasConfig == '0'">
                              <i
                                *ngIf="participante.presenca != '1'"
                                class="fal fa-circle"
                                (click)="changeCheck(participante)"
                              ></i>

                              <i
                                *ngIf="participante.presenca == '1' && !userProvider.hasConfig(193)"
                                class="fas fa-check"
                                style="color: #1dbb00"
                              ></i>

                              <i
                                *ngIf="participante.presenca == '1' && userProvider.hasConfig(193)"
                                (click)="retirarCheckin(participante)"
                                class="fas fa-check"
                                style="color: #1dbb00"
                              ></i>
                            </ion-note>
                          </ion-col>
                        </ion-row>
                      </ion-grid>
                    </ion-item>

                    <ion-item-options side="end">
                      <ion-item-option expandable *ngIf="isEnsino && atividades.length" (click)="notas(participante)"
                        class="check">
                        <span> {{'Dar Notas' | translate}} </span>
                      </ion-item-option>

                      <ion-item-option expandable color="danger"
                        *ngIf="participante.presenca == '1' && (!participante.saida || participante.saida == '0')"
                        (click)="checkOut(slidingItem, participante, i)" class="check">
                        <span> {{'Saída' | translate}} </span>
                      </ion-item-option>
                    </ion-item-options>

                    <ion-item-options side="start" color="danger">
                      <ion-item-option 
                        expandable 
                        (click)="retirarServicos(participante)" 
                        class="check"
                        color="warning"
                        *ngIf="(participante.hasServico == '1' || isAvulso) && participante.idEventoEncontroPresenca"  
                      >
                        <span *ngIf="participante.hasServico == '1'" style="white-space: break-spaces">
                          {{'Retirar Serviços' | translate}}
                        </span>

                        <span *ngIf="participante.hasServico == '0'"> {{'Check-in' | translate}} </span>
                      </ion-item-option>

                      <ion-item-option 
                        expandable 
                        color="primary"
                        (click)="openDetails(participante)"
                      >
                        <span style="white-space: break-spaces">
                          {{'Detalhes' | translate}}
                        </span>
                      </ion-item-option>
                    </ion-item-options>
                  </ion-item-sliding>
                </ion-list>
              </ion-col>
            </ion-row>
          </div>

          <ion-row *ngIf="tabSelected == 'gerenciar' && isEnsino" class="ion-justify-content-center ion-padding-top">
            <ion-col size="8">
              <ion-button style="width: 100%" expand="block" class="btn-default" (click)="reposicao()">
                {{'Reposição' | translate}}
              </ion-button>
            </ion-col>
          </ion-row>

          <sem-registro *ngIf="!inscritosList.length"></sem-registro>

          <ion-infinite-scroll (ionInfinite)="loadInscritos($event)"
            *ngIf="pagination.currentPage < pagination.pageCount">
            <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
          </ion-infinite-scroll>
        </div>
      </div>
    </div>
  </ng-container>
</ion-content>

<ion-footer class="footer-segment">
  <ion-segment style="margin: 0; width: 100%" [(ngModel)]="tabSelected" (ionChange)="onSegmentChanged($event)"
    [scrollable]="true">
    <ion-segment-button value="aula" *ngIf="isEnsino">
      <ion-label>
        <i class="fa-solid fa-book-open"></i>
        <p>{{'Aula' | translate}}</p>
      </ion-label>
    </ion-segment-button>

    <ion-segment-button value="aula" *ngIf="!isEnsino">
      <ion-label>
        <i class="fa-solid fa-user-group"></i>
        <p>{{'Encontro' | translate}}</p>
      </ion-label>
    </ion-segment-button>

    <ion-segment-button value="notas" *ngIf="isEnsino && (isInscrito || isAdmin) && atividades.length">
      <ion-label>
        <i class="fa-solid fa-note-sticky"></i>
        <p>{{'Notas' | translate}}</p>
      </ion-label>
    </ion-segment-button>

    <ion-segment-button value="antigos" value="escala">
      <ion-label>
        <i class="fa-solid fa-address-book"></i>
        <p>{{'Escala' | translate}}</p>
      </ion-label>
    </ion-segment-button>

    <ion-segment-button value="gerenciar" *ngIf="isAdmin">
      <ion-label>
        <i class="fa-solid fa-gear"></i>
        <p>{{'Gerenciar' | translate}}</p>
      </ion-label>
    </ion-segment-button>
  </ion-segment>
</ion-footer>